import { createContext } from 'react';
export const TabListContext = createContext(null);
